import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=4454ccae"
import script from "./CategoryItem.vue?vue&type=script&lang=js"
export * from "./CategoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports